import { ErrorContext, } from '@thoughtspot/blink-context';
import _ from 'lodash';
import React, { useCallback, useContext, useEffect, useState } from 'react';
const useGetErrorBoundaryState = (handledErrors) => {
    const [handledErrorsCopy, setHandledErrorsCopy] = useState(handledErrors);
    const parentCtx = useContext(ErrorContext);
    const [errors, setErrors] = useState([]);
    const [combinedErrors, setCombinedErrors] = useState([]);
    useEffect(() => {
        setCombinedErrors([...parentCtx.combinedErrors, ...errors]);
    }, [errors, parentCtx.combinedErrors]);
    const postError = useCallback((errs) => {
        let handleableErrors = [];
        let nonHandleableErrors = [];
        if (handledErrors.indexOf('*') !== -1) {
            handleableErrors = errs;
            nonHandleableErrors = [];
        }
        else {
            handleableErrors = errs.filter(err => {
                return handledErrorsCopy.includes(err.code);
            });
            nonHandleableErrors = _.difference(errs, handleableErrors);
        }
        setErrors(handleableErrors);
        if (nonHandleableErrors.length !== 0) {
            parentCtx.postError(nonHandleableErrors);
        }
    }, [handledErrors, handledErrorsCopy, parentCtx]);
    const resetError = useCallback(() => {
        parentCtx.resetError();
        setErrors([]);
    }, []);
    return {
        errors,
        combinedErrors,
        postError,
        resetError,
    };
};
const ErrorBoundary = ({ children, handledErrors }) => {
    const { errors, combinedErrors, postError, resetError, } = useGetErrorBoundaryState(handledErrors);
    return (React.createElement(ErrorContext.Provider, { value: {
            errors,
            combinedErrors,
            postError,
            resetError,
        } }, typeof children === 'function'
        ? children(errors, resetError)
        : children));
};
export { ErrorBoundary };
//# sourceMappingURL=error-boundary.js.map